export const regions = {
  Africa: "Africa",
  "Australia-and-Oceania": "Australia and Oceania",
  "Central-America": "Central America",
  "East-Coast-North-America": "East Coast North America",
  "East-Coast-South-America": "East Coast South America",
  "Far-East": "Far East",
  Mediterranean: "Mediterranean",
  "Middle-East-and-India": "Middle East and India",
  "North-Europe": "North Europe",
  "Southeast-Asia": "Southeast Asia",
  "West-Coast-North-America": "West Coast North America",
  "West-Coast-South-America": "West Coast South America",
};
